import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Cep } from '../api/dto/cep';
import { Observable } from 'rxjs';
import { ApiCep } from '../api/dto/api-cep/api-cep';
import { Webservicecep } from '../api/dto/api-cep/webservicecep';

@Injectable({
    providedIn: 'root'
})
export class CepService{

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'cep/';
    private urlApi: string = UrlServidor.URL_API_CEP;
    
    buscarPorCodigo(cep?: string): Observable<Cep>  {
        return this.http.get<Cep>(this.url + cep);
    }

    buscarApi(codCep: string) : Observable<any>{
        return this.http.get<any>(this.urlApi + codCep);
    }

    salvar(cep: Cep): Observable<Cep> {
        return  this.http.post(this.url, cep);
    }
    
}